const AggregateAbrasionValue = [
  {
    id: 12,
    reinstatementCode: 1,
    gpText: "All Pre Coated Chippings",
  },
  {
    id: 14,
    reinstatementCode: 1,
    gpText: "SMA, Material to PD6691 Surface Courses",
  },
  {
    id: 12,
    reinstatementCode: 2,
    gpText: "All Pre Coated Chippings",
  },
  {
    id: 14,
    reinstatementCode: 2,
    gpText: "SMA, Material to PD6691 Surface Courses",
  },
  {
    id: 14,
    reinstatementCode: 3,
    gpText: "All Pre Coated Chippings",
  },
  {
    id: 16,
    reinstatementCode: 3,
    gpText: "SMA, Material to PD6691 Surface Courses",
  },
  {
    id: 14,
    reinstatementCode: 4,
    gpText: "All Pre Coated Chippings",
  },
  {
    id: 16,
    reinstatementCode: 4,
    gpText: "SMA, Material to PD6691 Surface Courses",
  },
  {
    id: 10,
    reinstatementCode: 5,
    gpText: "All Pre Coated Chippings",
  },
  {
    id: 12,
    reinstatementCode: 5,
    gpText: "SMA, Material to PD6691 Surface Courses",
  },
];

export default AggregateAbrasionValue;
